import React from 'react';
import { Icon } from '@sabre/spark-react-core';
import { arrayOf, number, string } from 'prop-types';
import { API_STATUS } from '../../utils/constants';

function RecordCount({ selectedRowIndices, totalRowCount, searchStatus }) {
   const rowSelectionIndicator =
      selectedRowIndices.length > 1
         ? `${selectedRowIndices.length} records selected`
         : `Record ${selectedRowIndices[0]} selected`;

   return (
      <div className='spark-bold spark-flex justify-between spark-pad-t-.5 row-selection-info'>
         <p>
            {rowSelectionIndicator} (Total {totalRowCount})
         </p>
         {searchStatus === API_STATUS.ABORTED ? (
            <Icon
               name='close-circle'
               className='spark-danger spark-mar-l-.5'
               size='md'
               style='fill'
               label='Aborted'
               title='Aborted'
            />
         ) : searchStatus === API_STATUS.IN_PROGRESS ? (
            <span
               className='progress-indicator spark-mar-l-.5'
               title='Loading...'
               label='Loading...'
               aria-label='Loading...'
            />
         ) : (
            ''
         )}
      </div>
   );
}

RecordCount.propTypes = {
   selectedRowIndices: arrayOf(string).isRequired,
   totalRowCount: number.isRequired,
   searchStatus: string.isRequired,
};

export default RecordCount;
